"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const featureToggle_1 = require("modules/featureToggle");
const stores_1 = require("../stores");
const types_1 = require("../types");
class DrippingPayloadUtil {
    constructor() {
        this.getPayload = (isNewPage) => {
            const isDrippingByClassEnabled = featureToggle_1.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.DrippingByClass);
            if (!isDrippingByClassEnabled) {
                return null;
            }
            const drippingPayload = isNewPage
                ? { drippingConfigs: this.getPayloadToCreatePage() }
                : { updatedDrippingConfigs: this.getPayloadToUpdatePage() };
            return drippingPayload;
        };
        this.getPayloadToCreatePage = () => {
            const drippingsPayload = stores_1.DrippingStore.items.map((item) => {
                const drippingPayload = {
                    liberation: this.getLiberation(item),
                    expiration: this.getExpiration(item),
                    classes: item.classes.map((classItem) => classItem.hashId)
                };
                return drippingPayload;
            });
            return drippingsPayload;
        };
        this.getPayloadToUpdatePage = () => {
            const deleted = stores_1.DrippingStore.deletedItems;
            const saved = stores_1.DrippingStore.items.reduce((accumulator, drippingItem) => {
                if (!drippingItem.id) {
                    accumulator.push({
                        liberation: this.getLiberation(drippingItem),
                        expiration: this.getExpiration(drippingItem),
                        classes: drippingItem.classes.map((classItem) => classItem.hashId)
                    });
                }
                else if (drippingItem.id && drippingItem.isUpdated) {
                    accumulator.push({
                        id: drippingItem.id,
                        liberation: this.getLiberation(drippingItem),
                        expiration: this.getExpiration(drippingItem),
                        classes: drippingItem.classes.map((classItem) => classItem.hashId)
                    });
                }
                return accumulator;
            }, []);
            const drippingUpdatePayload = { saved, deleted };
            return drippingUpdatePayload;
        };
        this.getExpiration = ({ expirationDays }) => {
            if (expirationDays) {
                return {
                    type: 'BY_DAYS',
                    durationDays: expirationDays
                };
            }
            return null;
        };
        this.getLiberation = ({ releaseDays, releaseDate, pageId }) => {
            if (releaseDays) {
                return {
                    type: types_1.DrippingLiberationTypes.Days,
                    liberationDays: releaseDays
                };
            }
            if (releaseDate) {
                return {
                    type: types_1.DrippingLiberationTypes.Date,
                    liberationDate: releaseDate
                };
            }
            if (pageId) {
                return {
                    type: types_1.DrippingLiberationTypes.Quiz,
                    pageId
                };
            }
            return null;
        };
    }
}
exports.default = new DrippingPayloadUtil();
